import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getCoreFields, getOrganizationCustomFields } from "./actions";

export const fieldsEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity?._id,
});

const initialState = fieldsEntityAdapter.getInitialState({});

export const fieldsSlice = createSlice({
  name: "fields",
  initialState: initialState,
  reducers: {
    clearAllFields: (state) => {
      fieldsEntityAdapter.removeAll(state);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCoreFields.fulfilled, (state, action) => {
      if (action.payload?.status && action.payload?.data) {
        fieldsEntityAdapter.setAll(state, action.payload.data);
      }
    });
    builder.addCase(getOrganizationCustomFields.fulfilled, (state, action) => {
      if (action.payload?.status && action.payload?.data) {
        fieldsEntityAdapter.setAll(state, action.payload.data);
      }
    });
  },
});

export const { clearAllFields } = fieldsSlice.actions;

export default fieldsSlice.reducer;
